const canvasSketch = require('canvas-sketch');
const random = require('canvas-sketch-util/random');
const seedRandom = require('seed-random');
const ohash = require('object-hash');
const { createNoise2D } = require('simplex-noise');
const alea = require('alea')
const rough = require('roughjs/bundled/rough.cjs.js')

var seed, 
    seeded;

/* 
  Cool outputs:
  --
  oomzaFr5H7BLVQ7cieYuK1NNwRKrr4KHNS76SkQ61Mb3pxMHvzP
  ooUjFvtQ4uxtDQznw5w8JMT5EQj2XFY4fy8GEGZSJ9Q5nLVcAsp
  oo8UT3zBxG1qfZNiaXSWJo1NnEZ747g2KmtoqzafiqTEXj6YE1b

  TODO:
  --
  Set features

*/

const settings = {
  dimensions        : [ 800, 800 ],
  pixelsPerInch     : 300,
  pixelRatio        : 2,
  exportPixelRatio  : 5,
  scaleToFit        : true,
  scaleToFitPadding : 0,
  units             : 'px',
}

const stellar_colors = [
  [157, 180, 255],
  [162, 185, 255],
  [162, 185, 255],
  [162, 185, 255],
  [167, 188, 255],
  [170, 191, 255],
  [175, 195, 255],
  [186, 204, 255],
  [192, 209, 255],
  [202, 216, 255],
  [228, 232, 255],
  [237, 238, 255],
  [251, 248, 255],
  [255, 249, 249],
  [255, 245, 236],
  [255, 244, 232],
  [255, 241, 223],
  [255, 235, 209],
  [255, 215, 174],
  [255, 198, 144],
  [255, 190, 127],
  [255, 187, 123],
  [255, 187, 123],
]

window.$fxhashFeatures = {}

function setFeature(key, value) {
  console.log(key, value)
  if (window.$fxhashFeatures[key] != undefined)
    window.$fxhashFeatures[key] += value
  else
    window.$fxhashFeatures[key] = value
}

// Helpsers

let noise = null 

function dist(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
}

function map(value, start1, stop1, start2, stop2) {
    return start2 + (stop2 - start2) * ((value - start1) / (stop1 - start1));
}

const TWO_PI = 2 * Math.PI;

const getRandomColor = (opacity=1) => {
  const c = seeded.pick(stellar_colors)    
  return `rgba(${c[0]},${c[1]},${c[2]},${opacity})`
}

const sketch = () => {
  return ({ canvas, context, width, height }) => {
    seed = window.fxhash || Math.random()*1000
    //seed = 'oo8UT3zBxG1qfZNiaXSWJo1NnEZ747g2KmtoqzafiqTEXj6YE1b'
    console.log('seed', seed)
    seedRandom(seed, { global: true })
    noise = createNoise2D(alea(seed))
    seeded = random.createRandom(seed)
    paintBackground(context, width, height)
    paintGrid({ canvas, width, height })
    paintChladi({ ctx: context, width, height })
    let negativeLottery = seeded.range(0,10)
    //console.log(`negativeLottery: ${negativeLottery}`)
    if (negativeLottery > 9.5) {
      createNegative({ context, width, height, canvas })
    } else {
      setFeature('negative', false)
      setFeature('negative-split', 'none')
    }
  }
}

function paintGrid({ canvas, width, height }) {
    const rc = rough.canvas(canvas);
    let opacity = 0.2
    const angle = seeded.range(0, 360)
    let gap = seeded.range(20, 50)
    let roughness = seeded.range(7,15)
    let fillWeight = seeded.range(0.2, 0.5) // TODO: increase for all?
    let style = seeded.pick(['hachure', 'cross-hatch', 'dots', 'dashed', 'zigzag-line'])
    setFeature('background-style', style)
    if (style === 'hachure') {
      gap = seeded.range(30,60) 
      roughness = seeded.range(60,90)
      fillWeight = seeded.range(0.3, 0.7)
    }
    if (style === 'dots') {
      gap = seeded.range(50,100) 
      roughness = seeded.range(50,70)
      opacity=0.1
    }
    if (style === 'dashed') {
      gap = seeded.range(8,19)
    }
    const color = getRandomColor(opacity)
//    console.log(`
//style: ${style}
//anlge: ${angle}
//gap: ${gap}
//roughness: ${roughness}
//fillWeight: ${fillWeight}
//`)
    rc.rectangle(0, 0, width, height, {
      fill: color,
      fillWeight: fillWeight,
      hachureAngle: angle, 
      hachureGap: gap,
      stroke: 'transparent',
      roughness: roughness,
      fillStyle: style
    })
}

let bgcolorpicked = false
function paintBackground(context, width, height) {
  context.beginPath()
  context.fillStyle = 'black'
  context.fillRect(0,0, width, height)
  context.closePath()
}

function createNegative({ context, canvas }) {
  setFeature('negative', true)
  let x=0
  let y=0
  let _width = canvas.width
  let _height = canvas.height
  const negativesplit = seeded.pick(['vertical', 'horizontal', 'full'])
  setFeature('negative-split', negativesplit)
  if (negativesplit === 'vertical') _width = _width/2
  if (negativesplit === 'horizontal') _height = _height/2
  var imageData = context.getImageData(x, y, _width, _height);
  var dataArr = imageData.data;
  for(var i = 0; i < dataArr.length; i += 4)
  {
      var r = dataArr[i]; // Red color lies between 0 and 255
      var g = dataArr[i + 1]; // Green color lies between 0 and 255
      var b = dataArr[i + 2]; // Blue color lies between 0 and 255
      var a = dataArr[i + 3]; // Transparency lies between 0 and 255

      var invertedRed = 255 - r;
      var invertedGreen = 255 - g;
      var invertedBlue = 255 - b;

      dataArr[i] = invertedRed;
      dataArr[i + 1] = invertedGreen;
      dataArr[i + 2] = invertedBlue;
  }
          
  context.putImageData(imageData, x, y);
}

function paintChladi({ width, height, ctx }) {
    var xoff = 0;
    var yoff = 0;
    var inc = 0.01;
    let size = 4
    let sizeLottery = seeded.range(0,10)
    if (sizeLottery > 9) {
      setFeature('size', 'large')
      size = 3
    } else {
      setFeature('size', 'normal')
    }
    var civilizations = [
        {x: width/2, y: width/2, radius: width/size}, 
    ];
    const curve_1 = seeded.range(1.5,10)
    const curve_2 = seeded.range(1.5,3)
    const lineWidth = seeded.range(1,3)
    let opacity = seeded.range(0.3,0.8)
    let c = seeded.pick(stellar_colors)
    let c2 = seeded.pick(stellar_colors.filter(_c => _c != c))
    let c3 = seeded.pick(stellar_colors.filter(_c => _c != c && _c != c2))
    const singleColor = Array.from(new Array(30)).map(i => 'single-color')
    const gradedOpacity = Array.from(new Array(10)).map(i => 'graded-opacity')
    const randomColor = Array.from(new Array(1)).map(i => 'random-color')
    const moduloColor = Array.from(new Array(5)).map(i => 'modulo-color')
    const rangeColor = Array.from(new Array(5)).map(i => 'range-color')
    const moduloRange = seeded.range(2,10)
    let colorLottery = seeded.pick(gradedOpacity.concat(randomColor, singleColor,moduloColor,rangeColor))
    //console.log(`colorLottery: ${colorLottery}`)
    setFeature('color-style', colorLottery)
    for (var i = 0; i < civilizations.length; i++) {
        var civilization = civilizations[i];
        for (var y = civilization.y - civilization.radius; y <= civilization.y + civilization.radius; y += curve_1) {
            xoff = 0;
            ctx.beginPath();
            if (colorLottery === 'graded-opacity') {
              // 30% graded opacity
              opacity = seeded.range(0,1)
            }
            if (colorLottery === 'random-color') {
              c = seeded.pick(stellar_colors)
              opacity = seeded.range(0,1)
            }
            if (colorLottery === 'modulo-color') {
              if (y % moduloRange > 1) c = c2
              else c = c3
            }
            if (colorLottery === 'range-color') {
              const colorIndex = (Math.round(y / 30))
              c = stellar_colors[colorIndex]
            }
            ctx.strokeStyle = `rgba(${c[0]},${c[1]},${c[2]},${opacity})`
            ctx.lineWidth = lineWidth 
            for (var x = civilization.x - civilization.radius; x <= civilization.x + civilization.radius; x += curve_2) {
                var distance = dist(x, y, civilization.x, civilization.y);
                var angle = map(distance, 0, civilization.radius, 0, TWO_PI);
                var x1 = x + 10 * Math.cos(angle + noise(xoff, yoff) * TWO_PI);
                var y1 = y + 10 * Math.sin(angle + noise(xoff, yoff) * TWO_PI);
                ctx.lineTo(x1, y1);
                xoff += inc;
            }
            yoff += inc;
            ctx.stroke();
        }
    }
}

canvasSketch(sketch, settings);
